/**
 * Nueva venta: no vaciar líneas solo porque el listado de presupuestos
 * se refetchó al recuperar foco (HomePage → dataRefresh).
 */

export type ShouldClearVentaLinesArgs = {
  usePresupuesto: boolean;
  selectedId: string;
  /** True cuando solo cambió el array de presupuestos (refetch), no el modo/selección. */
  presupuestosChanged: boolean;
};

/** Vaciar líneas manuales solo al salir del modo presupuesto (o cambio de selección), no por refetch. */
export function shouldClearVentaLines({
  usePresupuesto,
  selectedId: _selectedId,
  presupuestosChanged,
}: ShouldClearVentaLinesArgs): boolean {
  if (usePresupuesto) return false;
  if (presupuestosChanged) return false;
  return true;
}

export type ShouldHydrateVentaLinesArgs = {
  usePresupuesto: boolean;
  selectedId: string;
  /** True si cambió el modo o el presupuesto elegido (no un refetch del listado). */
  selectionOrModeChanged: boolean;
};

/** Hidratar líneas desde el presupuesto elegido solo cuando el usuario cambia modo/selección. */
export function shouldHydrateVentaLinesFromPresupuesto({
  usePresupuesto,
  selectedId,
  selectionOrModeChanged,
}: ShouldHydrateVentaLinesArgs): boolean {
  return Boolean(usePresupuesto && selectedId && selectionOrModeChanged);
}
